import React from "react";
import PropTypes from "prop-types";
import {MenuItem} from "./MenuItem";
import {i18nFormat} from "../../lib/i18nFormat";
import {useLocation} from "react-router-dom";

const menuItems = [
  { key: "account", title: i18nFormat("account.title"), glyph: "glyph-core-person-fill", navigateTo: "/" },
  { key: "orders", title: i18nFormat("orders.title"), glyph: "glyph-core-cart-fill", navigateTo: "/orders/" },
  {
    key: "subscriptions",
    title: i18nFormat("subscriptions.title"),
    glyph: "glyph-core-arrow-double-circular-rotated",
    navigateTo: "/subscriptions/"
  },
  { key: "devices", title: i18nFormat("devices.title"), glyph: "glyph-system-devices", navigateTo: "/devices/" },
  { key: "shs", title: i18nFormat("shs.title"), glyph: "glyph-core-nas", navigateTo: "/self-hosted-servers/" },
  { key: "backups", title: i18nFormat("backups.title"), glyph: "glyph-system-backups", navigateTo: "/backups/" },
];

export function Menu(props) {
  const location = useLocation();
  const activeIndex = menuItems.findIndex(item => item.navigateTo === location.pathname);

  return (
    <nav className="account-menu">
      <header className="account-menu__header">
        <img className="account-menu__header-icon" src={props.user.avatar.medium}
               srcSet={`${props.user.avatar.large} 2x`} alt={"Account avatar"}/>
        <div className="account-menu__header-info">
          <h2 className="account-menu__header-name">{props.user.fullname}</h2>
          <p className="account-menu__header-email">{props.user.email}</p>
        </div>
      </header>
      <div className="account-menu__list">
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.key}
            title={item.title}
            glyph={item.glyph}
            navigateTo={item.navigateTo}
            isActive={index === activeIndex}
          />
        ))}
      </div>
    </nav>
  );
}

Menu.propTypes = {
  user: PropTypes.shape({
    fullname: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    avatar: PropTypes.shape({
      medium: PropTypes.string.isRequired,
      large: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}